import React from "react"
import types from "prop-types"
import CategoryList from "shared/CategoryList"
import { CategoryResetContextProvider } from "contexts/CategoryResetContext"
import CategoryResetProcessingModal from "../modals/CategoryReset/CategoryResetProcessingModal"

const PHPCategoryList = ({ subdomain, ...rest }) => (
  <CategoryResetContextProvider>
    <CategoryList subdomain={subdomain} {...rest} />
    <CategoryResetProcessingModal subdomain={subdomain} />
  </CategoryResetContextProvider>
)

PHPCategoryList.propTypes = {
  subdomain: types.string.isRequired,
}

export default PHPCategoryList
